import { render } from "./Ordina.vue?vue&type=template&id=90a7ddca&scoped=true"
import script from "./Ordina.vue?vue&type=script&lang=js"
export * from "./Ordina.vue?vue&type=script&lang=js"

import "./Ordina.vue?vue&type=style&index=0&id=90a7ddca&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90a7ddca"]])

export default __exports__